/**
 * Design Packs — tenant'ın KOMPLE tasarım kimliği (docs/tap-ia-redesign.md devamı).
 * Bir paket = eksen değerleri (L1 cilt) + seam varyantları (L2 layout: login/dashboard/shell).
 * KİLİTLİ model: tenant paket seçtiyse tenant-düzeyi eksen ayarları YOK SAYILIR (tutarlılık);
 * son kullanıcının kişisel Görünüm tercihleri ayrı katmandır ve çalışmaya devam eder.
 * Yeni paket eklemek = buraya bir kayıt (+ gerekiyorsa yeni varyant bileşeni/CSS'i).
 */
export interface DesignPack {
    id: string
    name: string
    /** appearance eksen değerleri (config/themes.ts sözlüğü) */
    axes: Record<string, string>
    /** login seam varyantı */
    login: 'centered' | 'split'
    /** dashboard seam varyantı */
    dash: 'classic' | 'bento'
}

export const PACKS: Record<string, DesignPack> = {
    default: {
        id: 'default', name: 'Default',
        axes: {}, // platform varsayılanları (mevcut tasarım)
        login: 'centered', dash: 'classic',
    },
    // Yeni paketler buraya: { id, name, axes, login, dash } (+ packs.css'te [data-pack="id"] sheet'i)
}

export const DEFAULT_PACK = 'default'
export const getPack = (id?: string | null): DesignPack => PACKS[id ?? ''] ?? PACKS[DEFAULT_PACK]!
